import { Box, Text } from '@factorialco/deprecated-design-system'
import DOMPurify from 'dompurify'
import { InputMaybe } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  content?: InputMaybe<string> | undefined
}

export const Description = ({ content }: Props) => {
  if (!content) return null

  return (
    <>
      <Box paddingY="s16">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('project_management.tasks.form.labels.description')}
        </Text.Normal>
      </Box>
      <Text.Normal>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(content),
          }}
        />
      </Text.Normal>
    </>
  )
}
